import StandardError from '@/modules/errors/Standard'

const TOO_MANY_REQUESTS = 429

class OtpRateLimitError extends StandardError {
  retryAfterSeconds: number

  constructor(retryAfterSeconds: number) {
    super(
      `You can request a new code in ${retryAfterSeconds} s`,
      TOO_MANY_REQUESTS,
    )
    this.retryAfterSeconds = retryAfterSeconds
  }
}
export default OtpRateLimitError
